import config from '../config/AppConfig'

export const baseURL = config.API_URL
export const timeout = config.API_REQUEST_TIMEOUT
